
// import { useEffect, useState } from "react";
// import {
//   Icon,
//   Reveal,
//   CountUp,
//   Eyebrow,
//   SectionHeading,
//   BtnPrimary,
//   BtnGhost,
//   FieldPattern,
//   Breadcrumb,
//   SERIF,
// } from "./ui";
// import { PressColumn } from "./Press";
// import CouncilLeadership from "./CouncilLeadership.jsx";
// import {
//   IMAGES,
//   SECTION_NAV,
//   OVERVIEW_PARAGRAPHS,
//   OVERVIEW_STATS,
//   STAKEHOLDERS,
//   CORE_FUNCTIONS,
//   PUBLICATIONS,
//   PRESS_RELEASES,
//   PRESS_COVERAGE,
//   EVENTS,
// } from "./data.jsx";

// /* ==================================================================
//    ASSOCHAM · SECTOR PAGE
//    Overview · Councils · Publications · Press Release · Press Coverage · Events
//    Palette: #DA2128 #DB2628 #DB6400 #F59C00 | #FAF7F2 #FEF7F4 #FFFFFF
// ================================================================== */

// /* =========================== MAIN COMPONENT =========================== */

// export default function SectorPage() {
//   const [progress, setProgress] = useState(0);
//   const [active, setActive] = useState("overview");

//   useEffect(() => {
//     const onScroll = () => {
//       const h = document.documentElement.scrollHeight - window.innerHeight;
//       setProgress(h > 0 ? (window.scrollY / h) * 100 : 0);
//     };
//     onScroll();
//     window.addEventListener("scroll", onScroll, { passive: true });
//     return () => window.removeEventListener("scroll", onScroll);
//   }, []);

//   useEffect(() => {
//     const sections = SECTION_NAV.map((s) => document.getElementById(s.id)).filter(Boolean);
//     if (!sections.length) return;
//     const io = new IntersectionObserver(
//       (entries) => {
//         const visible = entries
//           .filter((e) => e.isIntersecting)
//           .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
//         if (visible) setActive(visible.target.id);
//       },
//       { rootMargin: "-45% 0px -50% 0px", threshold: [0, 0.15, 0.4] }
//     );
//     sections.forEach((s) => io.observe(s));
//     return () => io.disconnect();
//   }, []);

//   // Smooth in-page scroll — stops the anchor's default nav so it never opens a new page/route.
//   const scrollToSection = (id) => (e) => {
//     e.preventDefault();
//     document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
//   };

//   return (
//     <div className="min-h-screen bg-[#FAF7F2] antialiased">
//       {/* ============================ STYLES ============================ */}
//       <style>{`
//         html { scroll-behavior: smooth; }
//         body { background:#FAF7F2; color:#1c1917; font-family: ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif; -webkit-font-smoothing: antialiased; }
//         ::selection { background:#DA2128; color:#fff; }
//         ::-webkit-scrollbar { width:10px; height:10px; }
//         ::-webkit-scrollbar-track { background:#FEF7F4; }
//         ::-webkit-scrollbar-thumb { background:linear-gradient(#DA2128,#DB6400); border-radius:9999px; }
//         @keyframes agri-float { 0%,100%{transform:translateY(0) rotate(0)} 50%{transform:translateY(-16px) rotate(3deg)} }
//         @keyframes agri-float-slow { 0%,100%{transform:translate(0,0)} 50%{transform:translate(10px,-22px)} }
//         @keyframes agri-sway { 0%,100%{transform:rotate(-6deg)} 50%{transform:rotate(6deg)} }
//         @keyframes agri-shine { 0%{transform:translateX(-120%) skewX(-20deg)} 60%,100%{transform:translateX(240%) skewX(-20deg)} }
//         @keyframes agri-pulse-ring { 0%{transform:scale(.85);opacity:.7} 70%{transform:scale(1.5);opacity:0} 100%{opacity:0} }
//         @keyframes agri-blob { 0%,100%{border-radius:62% 38% 46% 54% / 55% 48% 52% 45%} 50%{border-radius:42% 58% 66% 34% / 38% 62% 38% 62%} }
//         .anim-float{animation:agri-float 7s ease-in-out infinite}
//         .anim-float-slow{animation:agri-float-slow 11s ease-in-out infinite}
//         .anim-sway{animation:agri-sway 5s ease-in-out infinite;transform-origin:bottom center}
//         .anim-blob{animation:agri-blob 14s ease-in-out infinite}
//         .anim-pulse-ring{animation:agri-pulse-ring 2.6s cubic-bezier(.22,.61,.36,1) infinite}
//         .shine-parent{position:relative;overflow:hidden}
//         .shine-parent::after{content:"";position:absolute;top:0;bottom:0;left:0;width:45%;background:linear-gradient(90deg,transparent,rgba(255,255,255,.45),transparent);transform:translateX(-120%) skewX(-20deg)}
//         .shine-parent:hover::after{animation:agri-shine 1s ease-out}
//         .reveal{opacity:0;transform:translateY(26px);transition:opacity .7s cubic-bezier(.22,1,.36,1),transform .7s cubic-bezier(.22,1,.36,1)}
//         .reveal-left{opacity:0;transform:translateX(-32px);transition:opacity .8s cubic-bezier(.22,1,.36,1),transform .8s cubic-bezier(.22,1,.36,1)}
//         .reveal-right{opacity:0;transform:translateX(32px);transition:opacity .8s cubic-bezier(.22,1,.36,1),transform .8s cubic-bezier(.22,1,.36,1)}
//         .reveal-zoom{opacity:0;transform:scale(.94);transition:opacity .7s cubic-bezier(.22,1,.36,1),transform .7s cubic-bezier(.22,1,.36,1)}
//         .is-visible{opacity:1!important;transform:none!important}
//         @media (prefers-reduced-motion: reduce){*,*::before,*::after{animation-duration:.001ms!important;animation-iteration-count:1!important;transition-duration:.001ms!important}}
//       `}</style>

//       {/* ======================= SCROLL PROGRESS ======================= */}
//       <div className="fixed inset-x-0 top-0 z-[60] h-1">
//         <div
//           className="h-full bg-gradient-to-r from-[#DA2128] via-[#DB6400] to-[#F59C00] transition-[width] duration-150"
//           style={{ width: `${progress}%` }}
//         />
//       </div>
//       <button
//         type="button"
//         onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
//         aria-label="Back to top"
//         className={`fixed bottom-7 right-7 z-50 flex h-12 w-12 items-center justify-center rounded-full bg-[#DA2128] text-white shadow-xl shadow-[#DA2128]/35 transition-all duration-300 hover:-translate-y-1 hover:bg-[#DB6400] ${
//           progress > 8 ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-6 opacity-0"
//         }`}
//       >
//         <Icon name="chevron" className="h-5 w-5 rotate-180" strokeWidth={2.6} />
//       </button>

//       <main>
//         {/* ============================== HERO ============================== */}
//         <section id="home" className="relative overflow-hidden bg-stone-950">
//           <Breadcrumb />
//           <div className="absolute inset-0">
//             <img
//               src={IMAGES.field}
//               alt="Aerial view of a farmer in a lush green field"
//               className="h-full w-full object-cover opacity-45"
//             />
//             <div className="absolute inset-0 bg-gradient-to-br from-stone-950 via-stone-950/85 to-[#DA2128]/45" />
//           </div>
//           <FieldPattern className="text-white" opacity={0.07} />
//           <div className="anim-blob anim-float pointer-events-none absolute -right-28 top-10 h-80 w-80 bg-[#F59C00]/25 blur-3xl" />
//           <div className="anim-blob anim-float-slow pointer-events-none absolute -left-24 bottom-0 h-72 w-72 bg-[#DA2128]/30 blur-3xl" />

//           <div className="relative mx-auto max-w-7xl px-6 pb-16 pt-24 lg:pb-20 lg:pt-28">
//             <Reveal delay={60}>
//               <Eyebrow light>Agriculture &amp; Food Processing</Eyebrow>
//             </Reveal>
//             <Reveal delay={130}>
//               <h1
//                 style={SERIF}
//                 className="mt-5 max-w-3xl text-4xl font-bold leading-[1.08] tracking-tight text-white sm:text-5xl lg:text-[3.4rem]"
//               >
//                 Agri Industries &amp;
//                 <span className="mt-1 block bg-gradient-to-r from-[#F59C00] via-[#DB6400] to-[#DA2128] bg-clip-text text-transparent">
//                   Farming Practices Council
//                 </span>
//               </h1>
//             </Reveal>
//             <Reveal delay={200}>
//               <p className="mt-5 max-w-2xl text-[15px] leading-relaxed text-white/85">
//                 ASSOCHAM&apos;s national council for agriculture convenes industry, government and
//                 research to turn insight into policy — and policy into farm-level impact for 140+
//                 million farming families.
//               </p>
//             </Reveal>
//             <Reveal delay={280}>
//               <div className="mt-8 flex flex-wrap items-center gap-3">
//                 <BtnPrimary href="#overview" onClick={scrollToSection("overview")}>
//                   Sector overview
//                 </BtnPrimary>
//                 <BtnGhost href="#councils" light icon="users" onClick={scrollToSection("councils")}>
//                   Meet the council
//                 </BtnGhost>
//               </div>
//             </Reveal>
//           </div>

//           <svg
//             className="relative -mb-px block w-full text-[#FAF7F2]"
//             viewBox="0 0 1440 60"
//             preserveAspectRatio="none"
//             aria-hidden="true"
//           >
//             <path
//               fill="currentColor"
//               d="M0,32L80,35.3C160,39,320,45,480,44C640,43,800,32,960,30C1120,28,1280,35,1360,38.7L1440,42L1440,60L0,60Z"
//             />
//           </svg>
//         </section>

//         {/* ========================== SECTION NAV ========================== */}
        
//         {/* ============================= OVERVIEW ============================= */}
//         <section id="overview" className="relative scroll-mt-20 overflow-hidden bg-[#FAF7F2] py-20 lg:py-24">
//           <FieldPattern className="text-[#DB6400]" opacity={0.05} />
//           <div className="relative mx-auto grid max-w-7xl items-center gap-14 px-6 lg:grid-cols-2 lg:gap-16">
//             <Reveal variant="left">
//               <div className="relative">
//                 <div className="overflow-hidden rounded-[32px] border-4 border-white shadow-2xl shadow-stone-900/15">
//                   <img
//                     src={IMAGES.hero}
//                     alt="Indian farmer in a wheat field"
//                     className="h-[400px] w-full object-cover transition-transform duration-[1400ms] hover:scale-105"
//                     loading="lazy"
//                   />
//                 </div>
//                 <div className="anim-float absolute -bottom-8 -right-4 w-56 rounded-2xl bg-white p-5 shadow-2xl">
//                   <p className="text-[10.5px] font-bold uppercase tracking-[0.16em] text-[#DB6400]">
//                     Flagship Council
//                   </p>
//                   <p className="mt-2 text-[14.5px] font-bold leading-snug text-stone-900">
//                     Agri Industries &amp; Farming Practices
//                   </p>
//                   <div className="mt-3 flex items-center gap-2">
//                     <span className="relative flex h-2 w-2">
//                       <span className="anim-pulse-ring absolute inline-flex h-2 w-2 rounded-full bg-[#DA2128]" />
//                       <span className="relative inline-flex h-2 w-2 rounded-full bg-[#DA2128]" />
//                     </span>
//                     <span className="text-[11.5px] font-semibold text-stone-500">Active · FY 2025-26</span>
//                   </div>
//                 </div>
//                 <div className="anim-float-slow absolute -left-6 -top-8 hidden w-36 overflow-hidden rounded-2xl border-4 border-white shadow-xl sm:block">
//                   <img src={IMAGES.sower} alt="Farmer sowing seeds" className="h-24 w-full object-cover" loading="lazy" />
//                 </div>
//               </div>
//             </Reveal>

//             <div>
//               <SectionHeading
//                 align="left"
//                 eyebrow="Overview"
//                 title={
//                   <>
//                     Shaping India&apos;s{" "}
//                     <span className="text-[#DA2128]">agri-industrial agenda</span>
//                   </>
//                 }
//               />
//               {/* complete official overview copy */}
//               <div className="mt-6 space-y-4 border-l-2 border-[#DA2128]/20 pl-5">
//                 {OVERVIEW_PARAGRAPHS.map((p, i) => (
//                   <Reveal key={i} variant="right" delay={200 + i * 70}>
//                     <p className="text-[15.5px] leading-relaxed text-stone-600">
//                       {i === 0 ? (
//                         <>
//                           <span className="font-bold text-stone-900">ASSOCHAM</span>
//                           {p.replace("ASSOCHAM", "")}
//                         </>
//                       ) : (
//                         p
//                       )}
//                     </p>
//                   </Reveal>
//                 ))}
//               </div>

//             </div>
//           </div>

//         </section>

//         {/* ============================= COUNCILS ============================= */}
//         <section id="councils" className="relative scroll-mt-20 overflow-hidden bg-white py-20 lg:py-24">
//           <div className="pointer-events-none absolute inset-x-0 top-0 h-40 bg-gradient-to-b from-[#FAF7F2] to-transparent" />
//           <div className="relative mx-auto max-w-7xl px-6">
//             <SectionHeading
//               eyebrow="Councils"
//               title="Council Leadership"
//               subtitle="The council is steered by industry leaders who bring decades of global agri-business experience to India's policy table."
//             />

//             <CouncilLeadership />
//           </div>
//         </section>

//         {/* =========================== PUBLICATIONS =========================== */}
//         <section
//           id="publications"
//           className="relative scroll-mt-20 overflow-hidden bg-gradient-to-b from-[#FEF7F4] via-[#FAF7F2] to-[#FEF7F4] py-20 lg:py-24"
//         >
//           <FieldPattern className="text-[#DB6400]" opacity={0.05} />
//           <div className="relative mx-auto max-w-7xl px-6">
//             <SectionHeading
//               eyebrow="Knowledge Hub"
//               title={<>Publications &amp; Reports</>}
//               subtitle="Evidence-based research produced in partnership with leading consulting firms and knowledge partners."
//             />
//             <div className="mt-14 grid gap-7 lg:grid-cols-3">
//               {PUBLICATIONS.map((p, i) => (
//                 <Reveal key={p.title} delay={i * 110}>
//                   <article className="group relative flex h-full flex-col overflow-hidden rounded-3xl border border-stone-200 bg-white transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl hover:shadow-[#DA2128]/10">
//                     <div className="relative h-36 overflow-hidden bg-gradient-to-br from-[#DA2128] via-[#DB2628] to-[#DB6400]">
//                       <svg
//                         className="absolute inset-0 h-full w-full text-white/20"
//                         viewBox="0 0 400 160"
//                         preserveAspectRatio="none"
//                         aria-hidden="true"
//                       >
//                         <path d="M0 120 Q60 90 120 118 T240 116 T400 96 L400 160 L0 160Z" fill="currentColor" />
//                         <path d="M0 138 Q80 112 160 136 T320 130 T400 124 L400 160 L0 160Z" fill="currentColor" opacity="0.6" />
//                       </svg>
//                       <Icon name="wheat" className="anim-sway absolute right-6 top-5 h-14 w-14 text-white/30" strokeWidth={1.3} />
//                       <div className="absolute left-6 top-5 flex flex-col gap-2">
//                         <span className="w-max rounded-full bg-white/20 px-3 py-1 text-[11px] font-bold uppercase tracking-[0.14em] text-white backdrop-blur">
//                           {p.date}
//                         </span>
//                         <span className="w-max rounded-full bg-white px-3 py-1 text-[11px] font-bold text-[#DA2128]">
//                           {p.partner}
//                         </span>
//                       </div>
//                     </div>
//                     <div className="flex flex-1 flex-col p-7">
//                       <h3
//                         style={SERIF}
//                         className="text-[19px] font-bold leading-snug text-stone-900 transition-colors group-hover:text-[#DA2128]"
//                       >
//                         {p.title}
//                       </h3>
//                       <p className="mt-3 flex-1 text-[14px] leading-relaxed text-stone-600">{p.text}</p>
//                       <div className="mt-6 flex items-center justify-between gap-3">
//                         <a
//                           href="#publications"
//                           className="inline-flex items-center gap-2 rounded-full border border-[#DA2128]/25 bg-[#FEF7F4] px-5 py-2.5 text-[12.5px] font-bold text-[#DA2128] transition-all duration-300 hover:bg-[#DA2128] hover:text-white"
//                         >
//                           Download PDF
//                           <Icon name="download" className="h-4 w-4" strokeWidth={2.2} />
//                         </a>
//                         <span className="text-[11.5px] font-semibold uppercase tracking-wide text-stone-400">
//                           {p.pages}
//                         </span>
//                       </div>
//                     </div>
//                   </article>
//                 </Reveal>
//               ))}
//             </div>
//           </div>
//         </section>

//         {/* ======================= PRESS RELEASE + COVERAGE ======================= */}
//         <section id="press" className="relative scroll-mt-20 overflow-hidden bg-[#FAF7F2] py-20 lg:py-24">
//           <FieldPattern className="text-[#DA2128]" opacity={0.04} />
//           <div className="relative mx-auto max-w-7xl px-6">
//             <SectionHeading
//               eyebrow="Newsroom"
//               title={
//                 <>
//                   Press Release &amp; <span className="text-[#DA2128]">Press Coverage</span>
//                 </>
//               }
//               subtitle="Official statements from the council secretariat, alongside how India's leading media covered our work."
//             />

//             {/* flex: two synchronized newsroom columns */}
//             <div className="mt-14 flex flex-col gap-12 lg:flex-row lg:gap-10">
//               <PressColumn
//                 kicker="Official Statements"
//                 title="Press Release"
//                 icon="news"
//                 items={PRESS_RELEASES}
//               />
//               <span className="hidden w-px shrink-0 bg-gradient-to-b from-transparent via-stone-300 to-transparent lg:block" />
//               <PressColumn
//                 kicker="In The Media"
//                 title="Press Coverage"
//                 icon="mic"
//                 items={PRESS_COVERAGE}
//               />
//             </div>
//           </div>
//         </section>

//         {/* =============================== EVENTS =============================== */}
//         <section id="events" className="relative scroll-mt-20 overflow-hidden bg-white py-20 lg:py-24">
//           <div className="relative mx-auto max-w-7xl px-6">
//             <div className="flex flex-wrap items-end justify-between gap-6">
//               <div className="max-w-2xl">
//                 <Reveal variant="left">
//                   <Eyebrow>Engagements &amp; Events</Eyebrow>
//                 </Reveal>
//                 <Reveal variant="left" delay={80}>
//                   <h2
//                     style={SERIF}
//                     className="mt-5 text-3xl font-bold leading-tight tracking-tight text-stone-900 sm:text-4xl lg:text-[2.6rem]"
//                   >
//                     Recent &amp; Upcoming Initiatives
//                   </h2>
//                 </Reveal>
//               </div>
//               <Reveal variant="right" delay={120}>
//                 <BtnGhost href="#events">View all events</BtnGhost>
//               </Reveal>
//             </div>

//             <div className="relative mt-16">
//               <span className="absolute left-[27px] top-2 hidden h-[calc(100%-2rem)] w-[2px] bg-gradient-to-b from-[#DA2128] via-[#DB6400] to-transparent md:block" />
//               <div className="space-y-8">
//                 {EVENTS.map((e, i) => (
//                   <Reveal key={e.title} delay={i * 120}>
//                     <div className="group relative md:pl-20">
//                       <span className="absolute left-0 top-8 hidden h-14 w-14 items-center justify-center rounded-2xl bg-white shadow-lg shadow-stone-900/5 ring-1 ring-stone-200 transition-all duration-500 group-hover:bg-gradient-to-br group-hover:from-[#DA2128] group-hover:to-[#DB6400] group-hover:ring-transparent md:flex">
//                         <Icon
//                           name="calendar"
//                           className="h-6 w-6 text-[#DA2128] transition-colors duration-500 group-hover:text-white"
//                           strokeWidth={1.8}
//                         />
//                       </span>
//                       <article className="relative overflow-hidden rounded-3xl border border-stone-200 bg-white p-7 transition-all duration-500 hover:-translate-y-1 hover:border-[#DA2128]/30 hover:shadow-2xl hover:shadow-[#DA2128]/10 sm:p-9">
//                         <span className="absolute inset-y-0 left-0 w-1.5 origin-top scale-y-0 bg-gradient-to-b from-[#DA2128] to-[#F59C00] transition-transform duration-500 group-hover:scale-y-100" />
//                         <div className="flex flex-wrap items-center gap-3">
//                           <span className="rounded-full bg-[#DA2128] px-3.5 py-1 text-[11px] font-bold uppercase tracking-[0.12em] text-white">
//                             {e.tag}
//                           </span>
//                           <span className="rounded-full bg-[#FEF7F4] px-3.5 py-1 text-[11.5px] font-semibold text-[#DB6400]">
//                             {e.date}
//                           </span>
//                         </div>
//                         <h3 className="mt-5 text-[21px] font-bold leading-snug text-stone-900 transition-colors group-hover:text-[#DA2128] sm:text-2xl">
//                           {e.title}
//                         </h3>
//                         <p className="mt-2 flex items-center gap-1.5 text-[13px] font-medium text-stone-500">
//                           <Icon name="pin" className="h-4 w-4 text-[#DB6400]" strokeWidth={1.9} />
//                           {e.place}
//                         </p>
//                         <p className="mt-4 max-w-3xl text-[15px] leading-relaxed text-stone-600">{e.text}</p>
//                         <div className="mt-5 flex items-start gap-3 rounded-2xl bg-[#FAF7F2] p-4">
//                           <Icon name="check" className="mt-0.5 h-4 w-4 shrink-0 text-[#DA2128]" strokeWidth={2.8} />
//                           <p className="text-[13.5px] font-medium leading-relaxed text-stone-700">{e.highlight}</p>
//                         </div>
//                       </article>
//                     </div>
//                   </Reveal>
//                 ))}
//               </div>
//             </div>
//           </div>
//         </section>
//       </main>
//     </div>
//   );
// }







// new new code 




import { useEffect, useState } from "react";
import {
  Icon,
  Reveal,
  CountUp,
  Eyebrow,
  SectionHeading,
  BtnPrimary,
  BtnGhost,
  FieldPattern,
  Breadcrumb,
  SERIF,
} from "./ui";
import { PressColumn } from "./Press";
import CouncilLeadership from "./CouncilLeadership.jsx";
import {
  IMAGES,
  SECTION_NAV,
  OVERVIEW_PARAGRAPHS,
  OVERVIEW_STATS,
  STAKEHOLDERS,
  CORE_FUNCTIONS,
  PUBLICATIONS,
  PRESS_RELEASES,
  PRESS_COVERAGE,
  EVENTS,
} from "./data.jsx";
import { motion, AnimatePresence } from "framer-motion";
import { 
  TbMessage, 
  TbHandClick, 
  TbFileText, 
  TbBulb, 
  TbCircleCheck, 
  TbSend,
  TbMapPin,
  TbPhone,
  TbMail,
  TbClock
} from "react-icons/tb";

/* ==================================================================
   ASSOCHAM · SECTOR PAGE
   Overview · Councils · Publications · Press Release · Press Coverage · Events
   Palette: #DA2128 #DB2628 #DB6400 #F59C00 | #FAF7F2 #FEF7F4 #FFFFFF
================================================================== */

/* =========================== MAIN COMPONENT =========================== */

export default function SectorPage() {
  const [progress, setProgress] = useState(0);
  const [active, setActive] = useState("overview");
  const [submitted, setSubmitted] = useState(false);
  const [activeTab, setActiveTab] = useState("forthcoming");

  const C = {
    red: "#DA2128",
    gold: "#F59C00",
    dark: "#1c1917",
    white: "#FAF7F2",
    lightGray: "#E7E5E4",
  };

  // Filter events based on active tab
  const forthcomingEvents = EVENTS.filter(event => event.type === "forthcoming");
  const pastEvents = EVENTS.filter(event => event.type === "past");
  const displayedEvents = activeTab === "forthcoming" ? forthcomingEvents : pastEvents;

  useEffect(() => {
    const onScroll = () => {
      const h = document.documentElement.scrollHeight - window.innerHeight;
      setProgress(h > 0 ? (window.scrollY / h) * 100 : 0);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const sections = SECTION_NAV.map((s) => document.getElementById(s.id)).filter(Boolean);
    if (!sections.length) return;
    const io = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((e) => e.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (visible) setActive(visible.target.id);
      },
      { rootMargin: "-45% 0px -50% 0px", threshold: [0, 0.15, 0.4] }
    );
    sections.forEach((s) => io.observe(s));
    return () => io.disconnect();
  }, []);

  // Smooth in-page scroll — stops the anchor's default nav so it never opens a new page/route.
  const scrollToSection = (id) => (e) => {
    e.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Add your form submission logic here
    setSubmitted(true);
  };

  return (
    <div className="min-h-screen bg-[#FAF7F2] antialiased">
      {/* ============================ STYLES ============================ */}
      <style>{`
        html { scroll-behavior: smooth; }
        body { background:#FAF7F2; color:#1c1917; font-family: ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif; -webkit-font-smoothing: antialiased; }
        ::selection { background:#DA2128; color:#fff; }
        ::-webkit-scrollbar { width:10px; height:10px; }
        ::-webkit-scrollbar-track { background:#FEF7F4; }
        ::-webkit-scrollbar-thumb { background:linear-gradient(#DA2128,#DB6400); border-radius:9999px; }
        @keyframes agri-float { 0%,100%{transform:translateY(0) rotate(0)} 50%{transform:translateY(-16px) rotate(3deg)} }
        @keyframes agri-float-slow { 0%,100%{transform:translate(0,0)} 50%{transform:translate(10px,-22px)} }
        @keyframes agri-sway { 0%,100%{transform:rotate(-6deg)} 50%{transform:rotate(6deg)} }
        @keyframes agri-shine { 0%{transform:translateX(-120%) skewX(-20deg)} 60%,100%{transform:translateX(240%) skewX(-20deg)} }
        @keyframes agri-pulse-ring { 0%{transform:scale(.85);opacity:.7} 70%{transform:scale(1.5);opacity:0} 100%{opacity:0} }
        @keyframes agri-blob { 0%,100%{border-radius:62% 38% 46% 54% / 55% 48% 52% 45%} 50%{border-radius:42% 58% 66% 34% / 38% 62% 38% 62%} }
        .anim-float{animation:agri-float 7s ease-in-out infinite}
        .anim-float-slow{animation:agri-float-slow 11s ease-in-out infinite}
        .anim-sway{animation:agri-sway 5s ease-in-out infinite;transform-origin:bottom center}
        .anim-blob{animation:agri-blob 14s ease-in-out infinite}
        .anim-pulse-ring{animation:agri-pulse-ring 2.6s cubic-bezier(.22,.61,.36,1) infinite}
        .shine-parent{position:relative;overflow:hidden}
        .shine-parent::after{content:"";position:absolute;top:0;bottom:0;left:0;width:45%;background:linear-gradient(90deg,transparent,rgba(255,255,255,.45),transparent);transform:translateX(-120%) skewX(-20deg)}
        .shine-parent:hover::after{animation:agri-shine 1s ease-out}
        .reveal{opacity:0;transform:translateY(26px);transition:opacity .7s cubic-bezier(.22,1,.36,1),transform .7s cubic-bezier(.22,1,.36,1)}
        .reveal-left{opacity:0;transform:translateX(-32px);transition:opacity .8s cubic-bezier(.22,1,.36,1),transform .8s cubic-bezier(.22,1,.36,1)}
        .reveal-right{opacity:0;transform:translateX(32px);transition:opacity .8s cubic-bezier(.22,1,.36,1),transform .8s cubic-bezier(.22,1,.36,1)}
        .reveal-zoom{opacity:0;transform:scale(.94);transition:opacity .7s cubic-bezier(.22,1,.36,1),transform .7s cubic-bezier(.22,1,.36,1)}
        .is-visible{opacity:1!important;transform:none!important}
        .shimmer-text {
          background: linear-gradient(90deg, #DA2128, #F59C00, #DA2128);
          background-size: 200% 100%;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          animation: shimmer 3s linear infinite;
        }
        @keyframes shimmer {
          0% { background-position: 100% 0; }
          100% { background-position: -100% 0; }
        }
        .font-fraunces { font-family: 'Fraunces', Georgia, serif; }
        .font-fraunces-italic { font-family: 'Fraunces', Georgia, serif; font-style: italic; }
        @media (prefers-reduced-motion: reduce){*,*::before,*::after{animation-duration:.001ms!important;animation-iteration-count:1!important;transition-duration:.001ms!important}}
      `}</style>

      {/* ======================= SCROLL PROGRESS ======================= */}
      <div className="fixed inset-x-0 top-0 z-[60] h-1">
        <div
          className="h-full bg-gradient-to-r from-[#DA2128] via-[#DB6400] to-[#F59C00] transition-[width] duration-150"
          style={{ width: `${progress}%` }}
        />
      </div>
      <button
        type="button"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        aria-label="Back to top"
        className={`fixed bottom-7 right-7 z-50 flex h-12 w-12 items-center justify-center rounded-full bg-[#DA2128] text-white shadow-xl shadow-[#DA2128]/35 transition-all duration-300 hover:-translate-y-1 hover:bg-[#DB6400] ${
          progress > 8 ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-6 opacity-0"
        }`}
      >
        <Icon name="chevron" className="h-5 w-5 rotate-180" strokeWidth={2.6} />
      </button>

      <main>
        {/* ============================== HERO ============================== */}
        <section id="home" className="relative overflow-hidden bg-stone-950">
          <Breadcrumb />
          <div className="absolute inset-0">
            <img
              src={IMAGES.field}
              alt="Aerial view of a farmer in a lush green field"
              className="h-full w-full object-cover opacity-45"
            />
            <div className="absolute inset-0 bg-gradient-to-br from-stone-950 via-stone-950/85 to-[#DA2128]/45" />
          </div>
          <FieldPattern className="text-white" opacity={0.07} />
          <div className="anim-blob anim-float pointer-events-none absolute -right-28 top-10 h-80 w-80 bg-[#F59C00]/25 blur-3xl" />
          <div className="anim-blob anim-float-slow pointer-events-none absolute -left-24 bottom-0 h-72 w-72 bg-[#DA2128]/30 blur-3xl" />

          <div className="relative mx-auto max-w-7xl px-6 pb-16 pt-24 lg:pb-20 lg:pt-28">
            <Reveal delay={60}>
              <Eyebrow light>Agriculture &amp; Food Processing</Eyebrow>
            </Reveal>
            <Reveal delay={130}>
              <h1
                style={SERIF}
                className="mt-5 max-w-3xl text-4xl font-bold leading-[1.08] tracking-tight text-white sm:text-5xl lg:text-[3.4rem]"
              >
                Agri Industries &amp;
                <span className="mt-1 block bg-gradient-to-r from-[#F59C00] via-[#DB6400] to-[#DA2128] bg-clip-text text-transparent">
                  Farming Practices Council
                </span>
              </h1>
            </Reveal>
            <Reveal delay={200}>
              <p className="mt-5 max-w-2xl text-[15px] leading-relaxed text-white/85">
                ASSOCHAM&apos;s national council for agriculture convenes industry, government and
                research to turn insight into policy — and policy into farm-level impact for 140+
                million farming families.
              </p>
            </Reveal>
            <Reveal delay={280}>
              <div className="mt-8 flex flex-wrap items-center gap-3">
                <button
                  type="button"
                  onClick={scrollToSection("overview")}
                  className="inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-[#DA2128] to-[#DB6400] px-7 py-3.5 text-[13.5px] font-bold text-white shadow-lg shadow-[#DA2128]/30 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-xl"
                >
                  Sector overview
                  <Icon name="chevron" className="h-4 w-4" strokeWidth={2.5} />
                </button>
                <button
                  type="button"
                  onClick={scrollToSection("councils")}
                  className="inline-flex items-center gap-2 rounded-full border-2 border-white/30 px-7 py-3.5 text-[13.5px] font-bold text-white backdrop-blur transition-all duration-300 hover:border-white/60 hover:bg-white/10"
                >
                  <Icon name="users" className="h-4 w-4" strokeWidth={2.2} />
                  Meet the council
                </button>
              </div>
            </Reveal>
          </div>

          <svg
            className="relative -mb-px block w-full text-[#FAF7F2]"
            viewBox="0 0 1440 60"
            preserveAspectRatio="none"
            aria-hidden="true"
          >
            <path
              fill="currentColor"
              d="M0,32L80,35.3C160,39,320,45,480,44C640,43,800,32,960,30C1120,28,1280,35,1360,38.7L1440,42L1440,60L0,60Z"
            />
          </svg>
        </section>

        {/* ========================== SECTION NAV ========================== */}
        {/* <nav className="sticky top-1 z-40 border-b border-stone-200/80 bg-white/80 backdrop-blur-lg">
          <div className="mx-auto flex max-w-7xl items-center gap-1 overflow-x-auto px-6">
            {SECTION_NAV.map((item) => (
              <button
                key={item.id}
                type="button"
                onClick={scrollToSection(item.id)}
                className={`relative shrink-0 px-5 py-4 text-[12.5px] font-bold uppercase tracking-[0.08em] transition-colors duration-300 ${
                  active === item.id
                    ? "text-[#DA2128]"
                    : "text-stone-500 hover:text-stone-800"
                }`}
              >
                {item.label}
                {active === item.id && (
                  <span className="absolute inset-x-3 bottom-0 h-0.5 bg-gradient-to-r from-[#DA2128] to-[#DB6400]" />
                )}
              </button>
            ))}
            <button
              type="button"
              onClick={scrollToSection("secretariat")}
              className={`relative shrink-0 px-5 py-4 text-[12.5px] font-bold uppercase tracking-[0.08em] transition-colors duration-300 ${
                active === "secretariat"
                  ? "text-[#DA2128]"
                  : "text-stone-500 hover:text-stone-800"
              }`}
            >
              Contact
              {active === "secretariat" && (
                <span className="absolute inset-x-3 bottom-0 h-0.5 bg-gradient-to-r from-[#DA2128] to-[#DB6400]" />
              )}
            </button>
          </div>
        </nav> */}

        {/* ============================= OVERVIEW ============================= */}
        <section id="overview" className="relative scroll-mt-20 overflow-hidden bg-[#FAF7F2] py-20 lg:py-24">
          <FieldPattern className="text-[#DB6400]" opacity={0.05} />
          <div className="relative mx-auto grid max-w-7xl items-center gap-14 px-6 lg:grid-cols-2 lg:gap-16">
            <Reveal variant="left">
              <div className="relative">
                <div className="overflow-hidden rounded-[32px] border-4 border-white shadow-2xl shadow-stone-900/15">
                  <img
                    src={IMAGES.hero}
                    alt="Indian farmer in a wheat field"
                    className="h-[400px] w-full object-cover transition-transform duration-[1400ms] hover:scale-105"
                    loading="lazy"
                  />
                </div>
                <div className="anim-float absolute -bottom-8 -right-4 w-56 rounded-2xl bg-white p-5 shadow-2xl">
                  <p className="text-[10.5px] font-bold uppercase tracking-[0.16em] text-[#DB6400]">
                    Flagship Council
                  </p>
                  <p className="mt-2 text-[14.5px] font-bold leading-snug text-stone-900">
                    Agri Industries &amp; Farming Practices
                  </p>
                  <div className="mt-3 flex items-center gap-2">
                    <span className="relative flex h-2 w-2">
                      <span className="anim-pulse-ring absolute inline-flex h-2 w-2 rounded-full bg-[#DA2128]" />
                      <span className="relative inline-flex h-2 w-2 rounded-full bg-[#DA2128]" />
                    </span>
                    <span className="text-[11.5px] font-semibold text-stone-500">Active · FY 2025-26</span>
                  </div>
                </div>
                <div className="anim-float-slow absolute -left-6 -top-8 hidden w-36 overflow-hidden rounded-2xl border-4 border-white shadow-xl sm:block">
                  <img src={IMAGES.sower} alt="Farmer sowing seeds" className="h-24 w-full object-cover" loading="lazy" />
                </div>
              </div>
            </Reveal>

            <div>
              <SectionHeading
                align="left"
                eyebrow="Overview"
                title={
                  <>
                    Shaping India&apos;s{" "}
                    <span className="text-[#DA2128]">agri-industrial agenda</span>
                  </>
                }
              />
              <div className="mt-6 space-y-4 border-l-2 border-[#DA2128]/20 pl-5">
                {OVERVIEW_PARAGRAPHS.map((p, i) => (
                  <Reveal key={i} variant="right" delay={200 + i * 70}>
                    <p className="text-[15.5px] leading-relaxed text-stone-600">
                      {i === 0 ? (
                        <>
                          <span className="font-bold text-stone-900">ASSOCHAM</span>
                          {p.replace("ASSOCHAM", "")}
                        </>
                      ) : (
                        p
                      )}
                    </p>
                  </Reveal>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* ============================= COUNCILS ============================= */}
        <section id="councils" className="relative scroll-mt-20 overflow-hidden bg-white py-20 lg:py-24">
          <div className="pointer-events-none absolute inset-x-0 top-0 h-40 bg-gradient-to-b from-[#FAF7F2] to-transparent" />
          <div className="relative mx-auto max-w-7xl px-6">
            <SectionHeading
              eyebrow="Councils"
              title="Council Leadership"
              subtitle="The council is steered by industry leaders who bring decades of global agri-business experience to India's policy table."
            />
            <CouncilLeadership />
          </div>
        </section>

        {/* =========================== PUBLICATIONS =========================== */}
        <section
          id="publications"
          className="relative scroll-mt-20 overflow-hidden bg-gradient-to-b from-[#FEF7F4] via-[#FAF7F2] to-[#FEF7F4] py-20 lg:py-24"
        >
          <FieldPattern className="text-[#DB6400]" opacity={0.05} />
          <div className="relative mx-auto max-w-7xl px-6">
            <SectionHeading
              eyebrow="Knowledge Hub"
              title={<>Publications &amp; Reports</>}
              subtitle="Evidence-based research produced in partnership with leading consulting firms and knowledge partners."
            />
            <div className="mt-14 grid gap-7 lg:grid-cols-3">
              {PUBLICATIONS.map((p, i) => (
                <Reveal key={p.title} delay={i * 110}>
                  <article className="group relative flex h-full flex-col overflow-hidden rounded-3xl border border-stone-200 bg-white transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl hover:shadow-[#DA2128]/10">
                    <div className="relative h-36 overflow-hidden bg-gradient-to-br from-[#DA2128] via-[#DB2628] to-[#DB6400]">
                      <svg
                        className="absolute inset-0 h-full w-full text-white/20"
                        viewBox="0 0 400 160"
                        preserveAspectRatio="none"
                        aria-hidden="true"
                      >
                        <path d="M0 120 Q60 90 120 118 T240 116 T400 96 L400 160 L0 160Z" fill="currentColor" />
                        <path d="M0 138 Q80 112 160 136 T320 130 T400 124 L400 160 L0 160Z" fill="currentColor" opacity="0.6" />
                      </svg>
                      <Icon name="wheat" className="anim-sway absolute right-6 top-5 h-14 w-14 text-white/30" strokeWidth={1.3} />
                      <div className="absolute left-6 top-5 flex flex-col gap-2">
                        <span className="w-max rounded-full bg-white/20 px-3 py-1 text-[11px] font-bold uppercase tracking-[0.14em] text-white backdrop-blur">
                          {p.date}
                        </span>
                        <span className="w-max rounded-full bg-white px-3 py-1 text-[11px] font-bold text-[#DA2128]">
                          {p.partner}
                        </span>
                      </div>
                    </div>
                    <div className="flex flex-1 flex-col p-7">
                      <h3
                        style={SERIF}
                        className="text-[19px] font-bold leading-snug text-stone-900 transition-colors group-hover:text-[#DA2128]"
                      >
                        {p.title}
                      </h3>
                      <p className="mt-3 flex-1 text-[14px] leading-relaxed text-stone-600">{p.text}</p>
                      <div className="mt-6 flex items-center justify-between gap-3">
                        <button
                          type="button"
                          className="inline-flex items-center gap-2 rounded-full border border-[#DA2128]/25 bg-[#FEF7F4] px-5 py-2.5 text-[12.5px] font-bold text-[#DA2128] transition-all duration-300 hover:bg-[#DA2128] hover:text-white"
                        >
                          Download PDF
                          <Icon name="download" className="h-4 w-4" strokeWidth={2.2} />
                        </button>
                        <span className="text-[11.5px] font-semibold uppercase tracking-wide text-stone-400">
                          {p.pages}
                        </span>
                      </div>
                    </div>
                  </article>
                </Reveal>
              ))}
            </div>
          </div>
        </section>

        {/* ======================= PRESS RELEASE + COVERAGE ======================= */}
        <section id="press" className="relative scroll-mt-20 overflow-hidden bg-[#FAF7F2] py-20 lg:py-24">
          <FieldPattern className="text-[#DA2128]" opacity={0.04} />
          <div className="relative mx-auto max-w-7xl px-6">
            <SectionHeading
              eyebrow="Newsroom"
              title={
                <>
                  Press Release &amp; <span className="text-[#DA2128]">Press Coverage</span>
                </>
              }
              subtitle="Official statements from the council secretariat, alongside how India's leading media covered our work."
            />
            <div className="mt-14 flex flex-col gap-12 lg:flex-row lg:gap-10">
              <PressColumn
                kicker="Official Statements"
                title="Press Release"
                icon="news"
                items={PRESS_RELEASES}
              />
              <span className="hidden w-px shrink-0 bg-gradient-to-b from-transparent via-stone-300 to-transparent lg:block" />
              <PressColumn
                kicker="In The Media"
                title="Press Coverage"
                icon="mic"
                items={PRESS_COVERAGE}
              />
            </div>
          </div>
        </section>

        {/* =============================== EVENTS =============================== */}
        <section id="events" className="relative scroll-mt-20 overflow-hidden bg-white py-20 lg:py-24">
          <div className="relative mx-auto max-w-7xl px-6">
            <div className="flex flex-wrap items-end justify-between gap-6">
              <div className="max-w-2xl">
                <Reveal variant="left">
                  <Eyebrow>Engagements &amp; Events</Eyebrow>
                </Reveal>
                <Reveal variant="left" delay={80}>
                  <h2
                    style={SERIF}
                    className="mt-5 text-3xl font-bold leading-tight tracking-tight text-stone-900 sm:text-4xl lg:text-[2.6rem]"
                  >
                    Recent &amp; Upcoming Initiatives
                  </h2>
                </Reveal>
              </div>
              <Reveal variant="right" delay={120}>
                <button
                  type="button"
                  className="inline-flex items-center gap-2 rounded-full border-2 border-stone-300 px-6 py-3 text-[13px] font-bold text-stone-700 transition-all duration-300 hover:border-[#DA2128] hover:text-[#DA2128]"
                >
                  View all events
                  <Icon name="chevron" className="h-4 w-4" strokeWidth={2.2} />
                </button>
              </Reveal>
            </div>

            {/* Toggle Switch */}
            <div className="mt-10 flex justify-center">
              <div className="inline-flex rounded-full bg-stone-100 p-1 shadow-inner">
                <button
                  type="button"
                  onClick={() => setActiveTab("forthcoming")}
                  className={`relative rounded-full px-8 py-3 text-[13px] font-bold uppercase tracking-[0.08em] transition-all duration-300 ${
                    activeTab === "forthcoming"
                      ? "bg-white text-[#DA2128] shadow-lg"
                      : "text-stone-500 hover:text-stone-700"
                  }`}
                >
                  Forthcoming
                  {forthcomingEvents.length > 0 && (
                    <span className={`ml-2 rounded-full px-2 py-0.5 text-[10px] ${
                      activeTab === "forthcoming"
                        ? "bg-[#DA2128]/10 text-[#DA2128]"
                        : "bg-stone-200 text-stone-500"
                    }`}>
                      {forthcomingEvents.length}
                    </span>
                  )}
                </button>
                <button
                  type="button"
                  onClick={() => setActiveTab("past")}
                  className={`relative rounded-full px-8 py-3 text-[13px] font-bold uppercase tracking-[0.08em] transition-all duration-300 ${
                    activeTab === "past"
                      ? "bg-white text-[#DA2128] shadow-lg"
                      : "text-stone-500 hover:text-stone-700"
                  }`}
                >
                  Past
                  {pastEvents.length > 0 && (
                    <span className={`ml-2 rounded-full px-2 py-0.5 text-[10px] ${
                      activeTab === "past"
                        ? "bg-[#DA2128]/10 text-[#DA2128]"
                        : "bg-stone-200 text-stone-500"
                    }`}>
                      {pastEvents.length}
                    </span>
                  )}
                </button>
              </div>
            </div>

            {/* Events Timeline */}
            <div className="relative mt-12">
              <span className="absolute left-[27px] top-2 hidden h-[calc(100%-2rem)] w-[2px] bg-gradient-to-b from-[#DA2128] via-[#DB6400] to-transparent md:block" />
              <AnimatePresence mode="wait">
                <motion.div
                  key={activeTab}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -20 }}
                  transition={{ duration: 0.3 }}
                  className="space-y-8"
                >
                  {displayedEvents.length > 0 ? (
                    displayedEvents.map((e, i) => (
                      <div key={e.title} className="group relative md:pl-20">
                        <span className={`absolute left-0 top-8 hidden h-14 w-14 items-center justify-center rounded-2xl shadow-lg transition-all duration-500 md:flex ${
                          activeTab === "forthcoming"
                            ? "bg-gradient-to-br from-[#DA2128] to-[#DB6400]"
                            : "bg-gradient-to-br from-stone-400 to-stone-500"
                        }`}>
                          <Icon
                            name="calendar"
                            className="h-6 w-6 text-white"
                            strokeWidth={1.8}
                          />
                        </span>
                        <article className="relative overflow-hidden rounded-3xl border border-stone-200 bg-white p-7 transition-all duration-500 hover:-translate-y-1 hover:border-[#DA2128]/30 hover:shadow-2xl hover:shadow-[#DA2128]/10 sm:p-9">
                          <span className={`absolute inset-y-0 left-0 w-1.5 origin-top scale-y-0 transition-transform duration-500 group-hover:scale-y-100 ${
                            activeTab === "forthcoming"
                              ? "bg-gradient-to-b from-[#DA2128] to-[#F59C00]"
                              : "bg-gradient-to-b from-stone-400 to-stone-500"
                          }`} />
                          <div className="flex flex-wrap items-center gap-3">
                            <span className={`rounded-full px-3.5 py-1 text-[11px] font-bold uppercase tracking-[0.12em] text-white ${
                              activeTab === "forthcoming"
                                ? "bg-[#DA2128]"
                                : "bg-stone-500"
                            }`}>
                              {e.tag || (activeTab === "forthcoming" ? "Upcoming" : "Completed")}
                            </span>
                            <span className={`rounded-full px-3.5 py-1 text-[11.5px] font-semibold ${
                              activeTab === "forthcoming"
                                ? "bg-[#FEF7F4] text-[#DB6400]"
                                : "bg-stone-100 text-stone-500"
                            }`}>
                              {e.date}
                            </span>
                          </div>
                          <h3 className="mt-5 text-[21px] font-bold leading-snug text-stone-900 transition-colors group-hover:text-[#DA2128] sm:text-2xl">
                            {e.title}
                          </h3>
                          <p className="mt-2 flex items-center gap-1.5 text-[13px] font-medium text-stone-500">
                            <Icon name="pin" className="h-4 w-4 text-[#DB6400]" strokeWidth={1.9} />
                            {e.place}
                          </p>
                          <p className="mt-4 max-w-3xl text-[15px] leading-relaxed text-stone-600">{e.text}</p>
                          <div className="mt-5 flex items-start gap-3 rounded-2xl bg-[#FAF7F2] p-4">
                            <Icon name="check" className="mt-0.5 h-4 w-4 shrink-0 text-[#DA2128]" strokeWidth={2.8} />
                            <p className="text-[13.5px] font-medium leading-relaxed text-stone-700">{e.highlight}</p>
                          </div>
                        </article>
                      </div>
                    ))
                  ) : (
                    <div className="flex flex-col items-center justify-center py-16 text-center">
                      <Icon name="calendar" className="h-16 w-16 text-stone-300" strokeWidth={1.5} />
                      <p className="mt-4 text-lg font-medium text-stone-500">
                        No {activeTab === "forthcoming" ? "forthcoming" : "past"} events at the moment
                      </p>
                      <p className="mt-2 text-sm text-stone-400">
                        Check back soon for updates
                      </p>
                    </div>
                  )}
                </motion.div>
              </AnimatePresence>
            </div>
          </div>
        </section>

        {/* =============================== SECRETARIAT CONTACT =============================== */}
        <section id="secretariat" className="relative scroll-mt-20 overflow-hidden bg-gradient-to-b from-white to-[#FAF7F2] py-20 lg:py-24">
          <div className="relative mx-auto max-w-7xl px-6">
            <div className="grid gap-10 lg:grid-cols-2">
              {/* Left Column - Contact Information */}
              <div>
                <motion.div 
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  className="mb-3 inline-flex items-center gap-2"
                >
                  <div className="h-[2px] w-6 rounded-full bg-[#DA2128]" />
                  <span className="text-[10px] font-bold uppercase tracking-[0.25em] text-[#DA2128]">
                    Contact
                  </span>
                </motion.div>
                <motion.h2 
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: 0.1 }}
                  className="font-fraunces mb-3 text-3xl font-bold leading-[1.1] tracking-tight sm:text-4xl text-stone-900"
                >
                  Reach our <span className="font-fraunces-italic text-[#DA2128]">Secretariat</span>
                </motion.h2>
                <motion.p 
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: 0.2 }}
                  className="mb-8 text-sm leading-relaxed text-gray-600"
                >
                  The Agriculture Council is supported by a dedicated secretariat based at ASSOCHAM's headquarters in New Delhi.
                </motion.p>

                <div className="space-y-6">
                  {/* Address */}
                  <motion.div
                    initial={{ opacity: 0, x: -15 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ delay: 0.3 }}
                    viewport={{ once: true }}
                    className="flex items-start gap-4 rounded-xl p-4 hover:bg-red-50/30 transition-colors"
                  >
                    <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#DA2128]/10 text-[#DA2128]">
                      <TbMapPin className="h-5 w-5" strokeWidth={2} />
                    </div>
                    <div>
                      <h3 className="text-sm font-bold text-stone-900 mb-1">Address</h3>
                      <p className="text-sm leading-relaxed text-stone-600">
                        ASSOCHAM House,<br />
                        49–50, Rani Jhansi Road,<br />
                        New Delhi – 110 055, India
                      </p>
                    </div>
                  </motion.div>

                  {/* Phone */}
                  <motion.div
                    initial={{ opacity: 0, x: -15 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ delay: 0.4 }}
                    viewport={{ once: true }}
                    className="flex items-start gap-4 rounded-xl p-4 hover:bg-red-50/30 transition-colors"
                  >
                    <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#DA2128]/10 text-[#DA2128]">
                      <TbPhone className="h-5 w-5" strokeWidth={2} />
                    </div>
                    <div>
                      <h3 className="text-sm font-bold text-stone-900 mb-1">Phone</h3>
                      <a href="tel:+911146652222" className="text-sm font-semibold text-[#DA2128] hover:text-[#DB6400] transition-colors">
                        +91-11-4665 2222
                      </a>
                      <p className="text-xs text-stone-500 mt-0.5">Mon–Fri, 9:30 AM – 6:00 PM IST</p>
                    </div>
                  </motion.div>

                  {/* Email */}
                  <motion.div
                    initial={{ opacity: 0, x: -15 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ delay: 0.5 }}
                    viewport={{ once: true }}
                    className="flex items-start gap-4 rounded-xl p-4 hover:bg-red-50/30 transition-colors"
                  >
                    <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#DA2128]/10 text-[#DA2128]">
                      <TbMail className="h-5 w-5" strokeWidth={2} />
                    </div>
                    <div>
                      <h3 className="text-sm font-bold text-stone-900 mb-1">Email</h3>
                      <div className="space-y-1">
                        <a href="mailto:agriculture@assocham.com" className="block text-sm font-semibold text-[#DA2128] hover:text-[#DB6400] transition-colors">
                          agriculture@assocham.com
                        </a>
                        <p className="text-xs text-stone-500">
                          Council Director: <a href="mailto:d.s.rajora@assocham.com" className="text-[#DA2128] hover:text-[#DB6400] transition-colors">d.s.rajora@assocham.com</a>
                        </p>
                      </div>
                    </div>
                  </motion.div>
                </div>
              </div>

              {/* Right Column - Contact Form */}
              <motion.div
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                className="rounded-2xl bg-white p-6 shadow-xl border border-stone-200"
              >
                <AnimatePresence mode="wait">
                  {submitted ? (
                    <motion.div 
                      key="success" 
                      initial={{ opacity: 0, scale: 0.8 }} 
                      animate={{ opacity: 1, scale: 1 }} 
                      exit={{ opacity: 0, scale: 0.8 }} 
                      className="flex flex-col items-center justify-center py-10 text-center"
                    >
                      <motion.div 
                        initial={{ scale: 0 }} 
                        animate={{ scale: 1 }} 
                        transition={{ type: "spring", delay: 0.2 }} 
                        className="mb-3 flex h-16 w-16 items-center justify-center rounded-full bg-green-100"
                      >
                        <TbCircleCheck className="h-8 w-8 text-green-500" strokeWidth={2.2} />
                      </motion.div>
                      <h3 className="font-fraunces mb-1 text-xl font-bold text-stone-900">Query Submitted!</h3>
                      <p className="text-sm text-gray-500">Our team will respond within 48 hours.</p>
                    </motion.div>
                  ) : (
                    <motion.form 
                      key="form" 
                      initial={{ opacity: 0 }} 
                      animate={{ opacity: 1 }} 
                      onSubmit={handleSubmit} 
                      className="space-y-3"
                    >
                      <h3 className="font-fraunces text-xl font-bold text-stone-900">
                        Send us a <span className="font-fraunces-italic text-[#DA2128]">Message</span>
                      </h3>
                      <div className="grid gap-3 sm:grid-cols-2">
                        <input 
                          type="text" 
                          placeholder="Full Name" 
                          required 
                          className="w-full rounded-lg border border-gray-200 px-3 py-2.5 text-xs transition-all focus:border-red-500 focus:outline-none focus:ring-2 focus:ring-red-100" 
                        />
                        <input 
                          type="email" 
                          placeholder="Email" 
                          required 
                          className="w-full rounded-lg border border-gray-200 px-3 py-2.5 text-xs transition-all focus:border-red-500 focus:outline-none focus:ring-2 focus:ring-red-100" 
                        />
                      </div>
                      <input 
                        type="text" 
                        placeholder="Organization" 
                        className="w-full rounded-lg border border-gray-200 px-3 py-2.5 text-xs transition-all focus:border-red-500 focus:outline-none focus:ring-2 focus:ring-red-100" 
                      />
                      <select 
                        required 
                        className="w-full rounded-lg border border-gray-200 px-3 py-2.5 text-xs transition-all focus:border-red-500 focus:outline-none focus:ring-2 focus:ring-red-100"
                      >
                        <option value="">Select a category</option>
                        <option>Policy & Schemes</option>
                        <option>Investment Opportunities</option>
                        <option>Regulatory Compliance</option>
                        <option>Technology & Innovation</option>
                        <option>Market Access</option>
                        <option>Other</option>
                      </select>
                      <textarea 
                        rows={4} 
                        placeholder="Describe your query..." 
                        required 
                        className="w-full rounded-lg border border-gray-200 px-3 py-2.5 text-xs transition-all focus:border-red-500 focus:outline-none focus:ring-2 focus:ring-red-100" 
                      />
                      <motion.button 
                        whileHover={{ scale: 1.02 }} 
                        whileTap={{ scale: 0.98 }} 
                        type="submit" 
                        className="flex w-full items-center justify-center gap-2 rounded-lg py-3 text-xs font-bold text-white shadow-lg" 
                        style={{ background: `linear-gradient(135deg, #DA2128, #F59C00)` }}
                      >
                        <TbSend className="h-3.5 w-3.5" strokeWidth={2.2} />
                        Submit Query
                      </motion.button>
                    </motion.form>
                  )}
                </AnimatePresence>
              </motion.div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}